import { render, staticRenderFns } from "./Beta.vue?vue&type=template&id=540b1d66&"
import script from "./Beta.vue?vue&type=script&lang=ts&"
export * from "./Beta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports